export const CAMPAIGN_WORKSPACE_ROUTES = {
  CAMPAIGN_DRIVE: '/workspaces/campaign-drive',
  WORKSPACES: '/workspaces',
  PROJECTS: `/workspaces/projects`,
  ANALYTICS: '/workspaces/analytics',
  CAMPAIGNS: '/workspaces/campaign',
  NEW_WORKSPACE: '/workspace/new',
  EDIT_WORKSPACE: '/workspace/edit',
  TIMELINE_SIMULATOR: '/workspaces/timeline-simulator',
  NEW_COMPANY_PROJECTS: '/projects/new/company',
  TEMPORARY_REDIRECT: '/temporaryRedirect',
  CAMPAIGN_DRIVE_DASHBOARD: `/workspaces/campaigndrive/dashboard`,
};

export const CAMPAIGN_WORKSPACE_HEADER_LABELS = {
  DRIVE_CAMPAIGNS: 'driveCampaigns',
  CAMPAIGNS: 'campaigns',
  PROJECTS: 'projects',
  SHARED: 'shared',
  WORKSPACES: 'workspaces',
};

export const CAMPAIGN_WORKSPACE_COMPONENT_NAMES = {
  DRIVE_CAMPAIGN: 'Drive Campaigns',
  CAMPAIGN: 'Campaigns',
  PROJECT: 'Projects',
  SHARED: 'Shared',
  WORKSPACE: 'Workspaces',
  CAMPAIGN_DRIVE_COMPONENT: 'campaignDriveComponent',
  CAMPAIGN_DRIVE: 'campaign-drive',
  SHARED_COMPONENT: 'sharedComponent',
};

export const CAMPAIGN_WORKSPACE_TRANSLATIONS = {
  MENU_CAMPAIGNS_PROJECTS: 'menu_campaignsProjects',
  CAMPAIGN_NAME: 'campaignName',
  WORKSPACE_DELETE_TITLE: 'workspace_delete_title',
  WORKSPACE_DELETE_CONFIRM: 'workspace_delete_confirm',
  YES: 'yes',
  NO: 'no',
  ERROR_PERMISSION: "You don't have permission to access campaigns or drive campaigns.",
  THREE_LETTER_MONTH_PREFIX: '3letterMonth_',
  ALPHA_MODE: 'Alphabetical',
  STATUS_MODE: 'Status',
  ALL_WORKSPACES: 'All Workspaces',
  DRIVE_CAMPAIGN_DELETE_CONFIRM: 'deleteDriveCampaignConfirm',
  DRIVE_CAMPAIGN_DELETE_CONFIRM_QUESTION: 'deleteDriveCampaignConfirmQuestion',
  DRIVE_CAMPAIGN_ERROR_HAS_PROJECT: 'deleteDriveCampaign_error_hasProject',
  DRIVE_CAMPAIGN_ERROR: 'deleteDriveCampaign_error',
  INVALID_DELETE_CAMPAIGN_OPERATION: 'INVALID_DELETE_CAMPAIGN_OPERATION',
  PROJECTS_COMPONENT: 'projectsComponent',
  CAMPAIGN_NAME_PROJECTS: 'campaignName_projects',
  CANCEL: 'cancel',
  WARNING: 'Warning',
  LIMIT_STORAGE_MODAL: 'limit-storage-modal',
  ARCHIVED: 'archived',
  FAVORITES: 'favorites',
};

export const CAMPAIGN_WORKSPACE_CONSTANTS = {
  FAVORITE_TYPE: 'WORKSPACE',
  AGENCY: 'AGENCY',
  WORKSPACE_LOCAL_STORAGE_KEYS: {
    BRAND: 'brand',
    WORKSPACE: 'workspace',
  },
  CALENDAR_VIEW_MODES: {
    THREE_MONTHS: '3 Months',
    SIX_MONTHS: '6 Months',
    WEEK: 'Week',
    LAST_UPDATED: 'Latest',
    DATE: 'Date',
    MONTHS: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
  },
  CALENDAR_MODE_VALUES: {
    THREE_MONTHS: '3_months',
    SIX_MONTHS: '6_months',
    WEEK: 'week',
  },
  DRIVE_STATUS: [
    { value: 'IN_PROGRESS', label: 'In Progress' },
    { value: 'COMPLETED', label: 'Completed' },
    { value: 'DELAYED', label: 'Delayed' },
  ],
};

export const CAMPAIGN_WORKSPACE_KEYS = {
  ALL_WORKSPACES: 'all_workspaces',
};

export const CAMPAIGN_WORKSPACE_FORM_FIELDS = {
  CAMPAIGN_NAME: 'campaignName',
  COLLABORATORS: 'collaborators',
  LOGO: 'logo',
  BANNER: 'banner',
  STATUS: 'status',
  START_DATE: 'startDate',
  END_DATE: 'endDate',
  WORKSPACE: 'workspace',
};
export const CAMPAIGN_WORKSPACE_PROJECT_TYPES = {
  CAMPAIGN: 'CAMPAIGN',
  DRIVE_CAMPAIGN: 'DRIVE_CAMPAIGN',
  STANDALONE_PROJECT: 'STANDALONE_PROJECT',
};
